import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'dmmp-description',
  templateUrl: './description.component.html'
})
export class DescriptionComponent implements OnInit {
  @Input() data
  constructor() {}

  ngOnInit() {}
}
